import React from "react";
import { Box, Grid } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

export default function SkeletonDisponibilidadUmbral() {
    return (
        <Box sx={{ padding: { xs: 1, sm: 1, md: 2, lg: 3, xl: 3 } }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Box
                        sx={{
                            width: {
                                xs: "100%",
                                sm: "100%",
                                md: 250,
                                lg: 250,
                                xl: 250,
                            },
                            height: 70,
                        }}
                    >
                        <Skeleton
                            height="100%"
                            variant="rect"
                            style={{
                                backgroundColor: "#adadad",
                            }}
                        />
                    </Box>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    style={{ display: "flex", justifyContent: "end" }}
                >
                    <Box
                        sx={{
                            display: {
                                xs: "none",
                                sm: "none",
                                md: "block",
                                lg: "block",
                                xl: "block",
                            },
                            width: {
                                xs: "100%",
                                sm: "100%",
                                md: 250,
                                lg: 250,
                                xl: 250,
                            },
                            height: 70,
                        }}
                    >
                        <Skeleton
                            height="100%"
                            variant="rect"
                            style={{
                                backgroundColor: "#adadad",
                            }}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Box
                        sx={{
                            width: {
                                xs: "100%",
                                sm: "100%",
                                md: 350,
                                lg: 350,
                                xl: 350,
                            },
                            height: 60,
                        }}
                    >
                        <Skeleton
                            height="100%"
                            variant="text"
                            style={{
                                backgroundColor: "#adadad",
                            }}
                        />
                    </Box>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    xl={6}
                    style={{ display: "flex", justifyContent: "end" }}
                >
                    <Box
                        sx={{
                            width: {
                                xs: "100%",
                                sm: "100%",
                                md: 350,
                                lg: 350,
                                xl: 350,
                            },
                            height: 60,
                        }}
                    >
                        <Skeleton
                            height="100%"
                            variant="text"
                            style={{
                                backgroundColor: "#adadad",
                            }}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Skeleton
                        variant="rect"
                        height={40}
                        style={{
                            backgroundColor: "#adadad",
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
                    <Skeleton
                        variant="rect"
                        height={350}
                        style={{
                            backgroundColor: "#adadad",
                            borderRadius: "0.5rem",
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
                    <Skeleton
                        variant="rect"
                        height={350}
                        style={{
                            backgroundColor: "#adadad",
                            borderRadius: "0.5rem",
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
                    <Skeleton
                        variant="rect"
                        height={350}
                        style={{
                            backgroundColor: "#adadad",
                            borderRadius: "0.5rem",
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
                    <Skeleton
                        variant="rect"
                        height={350}
                        style={{
                            backgroundColor: "#adadad",
                            borderRadius: "0.5rem",
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}
